import { TApplicationState } from '../../types/redux';

export function getMedia(state: TApplicationState) {
  const {
    newbuilding: { media },
  } = state;

  return media && media.length ? media : null;
}
